module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-13.091afad8.png";